export default function maxTextWidth(texts: string[], font?: string) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    context.font = font || getComputedStyle(document.body).font;
    const sizes = texts.map(text => context.measureText(text).width);
    return Math.max(...sizes);
}